<template>
<div>
  <!-- navigation -->
<Navigation> </Navigation>
  <!-- navigation --> 

   <section class="home-container" id="home">
        <div class="container">
            <div class="row">
                <div class="col-lg-7 col-md-7">
                    <h3 class="display-4 home-main-text">
                        Paytime
                    </h3>
                    <h2>Money trsnsfer & online payment</h2>

                    <br>
                    <span>Everything you need to run. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Autem labore provident, inventore, atque voluptates, soluta cumque adipisci cum neque ipsum ullam distinctio ut possimus voluptatibus!</span>
                </div>

                <div class="col-lg-5 col-md-5">

                    
                <div v-if="canLogin==true">
                    <img src="imgs/img_helpdesk.png" class="img-fluid mt-5" alt="">
                </div>
                   

                   <div v-else-if="canRegister==false">
                    <h6  class="mt-5">Get started with your 10-days free trial</h6>
                    <div>
                        <input type="text" class="trial-form" placeholder="Email" />
                        <br>
                        <input type="text" class="mt-2 trial-form" placeholder="Password" />
                        <p>Powered by Aruvaa. Kindly read the terms of services before you proceed.</p>
                        <input type="checkbox" class="checkbox-form"> I agree to the <span class="terms-privacy-text"><a
                                href="">Terms of Services</a></span>
                        and <span class="terms-privacy-text"><a href="">Privacy Policy</a></span>
                        <br>
                        <br>
                        <a href="">
                            <button class="free-trial-btn">Start Free Trial</button>
                        </a>
                    </div>
                 </div>
                   
                </div>
            </div>
        </div>
    </section>
  <!-- helpdesk get the help end-->
   
   
     <div class="card-board">
      <div class="container">
      <div class="row">
          <div class="col-lg-6 home-payment">
             <h3 class="display-4 ">
                        Paytime
                    </h3>
                    <h2>Money trsnsfer & online payment. how Paytime can help you be more effective</h2>

                    <br>
                    <span>Everything you need to run. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Autem labore provident, inventore, atque voluptates, soluta cumque adipisci cum neque ipsum ullam distinctio ut possimus voluptatibus!</span>
          </div>
          <div class="col-lg-6">
        <div class="card">
            <div class="img"><img src="https://elzero.org/images/challenges/person-blue-shirt.png" alt=""></div>
            <div class="text">
                <h2>Paytime</h2>
                <p>Full Stack Web Developer</p>
            </div>
            <div class="social">
                <div>
                    <p>Product</p>
                    <p>OsElzero</p>
                </div>
                <div>
                    <p>Client</p>
                    <p>Osama_Elzero</p>
                </div>
                <div>
                    <p>organisation</p>
                    <p>Osama Elzero</p>
                </div>
            </div>
        </div>
        </div>
    </div>
    </div> 
</div>
  </div>  
</template>

<script>
 import { Head, Link } from '@inertiajs/inertia-vue3';
    import Navigation from "@/Layouts/Navigation.vue";
    import AppLayout from "@/Layouts/AppLayout.vue";
      import JetNavLink from '@/Jetstream/NavLink.vue'
export default {
 props: {
            canLogin: Boolean,
            canRegister: Boolean,
        },
        components: {
            AppLayout,
            Navigation,
            JetNavLink,
        },
         data() {
        return {
            //url: '/' 
        }
    }   
}
</script>

<style>
*{
  
    box-sizing: border-box;
}

.card-board {
    width: auto;
    height: 650px;
    background-color: rgb(15, 17, 107);
    margin: auto;
    position: relative;
    z-index: -1;
}
@media (max-width: 800px) {
    .card-board {
        width: 100%;
    }
}
.card-board .card {
    width: 400px;
    height: 400px;
    background-color: #eee;
    position: relative;
    top: 20%;
    transform: translate(50%);
    border-radius: 5px;
}
.card-board .img img {
    right: 50%;
    transform: translatex(50%);
    top: -110px;
    position: absolute;
    z-index: 1;
}
/* .card-board .card::after {
    content: "A+";
    color: white;
    font-weight: 600;
    position: absolute;
    right: 15px;
    bottom: -20px;
    background-color: #3B74BA;
    padding: 10px;
    border-radius: 5px;
} */
.card-board .card .text {
    margin-top: 40px;
    text-align: center;
}
.card-board .card .text h2 {
    padding-top: 50px;
    padding-bottom: 10px;
    color: #3B74BA;
}
.card-board .card .text p {
    color: #777;
}
.social {
    margin-top: 100px;
}
.social div {
    background-color: #ddd;
    display: flex;
    justify-content: space-between;
    margin: 20px 20px;
    padding: 10px;
}
.social .social-social {
    margin: 5px;
    display: block;
}
.mmoo {
    display: block;
    height: 2px;
}

/* next css */
  .home-container {
        display: grid;
        height: 80vh;
        place-content: center;
        place-items: center;
    }
      @media only screen and (min-width: 400px) {
        .content {
            display: none;
        }

        .home-main-text {
            margin-top: 44%;
        }

        .cloud-divider {
            margin-top: 190px;
        }
    }

     /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
        .content {
            display: none;
        }

        .home-main-text {
            margin-top: 39%;
        }

        .cloud-divider {
            margin-top: 180px;
        }
    }

     /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
        .content {
            display: none;
        }

        .home-main-text {
            margin-top: 45px;
        }

        .cloud-divider {
            margin-top: 0px;
        }
    }

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {
        .content {
            display: block;
        }

        .home-main-text {
            margin-top: 40px;
        }

        .cloud-divider {
            margin-top: 0px;
        }
    }

      /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        .home-container {
            margin-top: 120px;
        }
    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
        .home-container {
            margin-top: 70px;
        }
    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
        .home-container {
            margin-top: 50px;
        }
    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {
        .home-container {
            margin-top: 50px;
        }
    }

     /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {
        .home-container {
            margin-top: 0px;
        }
    }

     .free-trial-btn {
        width: 100%;
        border: 1px solid #FF4B69;
        background-color: #FF4B69;
        color: white;
    }
    .home-payment h3{
        color: white;
        margin-top: 170px;
    }

    .home-payment h2{
        color: white;
    }

    .home-payment span{
        color: white;
    }

    
</style>